"use strict";
// Polyfill CustomEvent
(function () {
    try {
        // tslint:disable-next-line:no-unused-expression
        new window.CustomEvent("t");
        return; // use native implementation
    }
    catch (e) {
        // IE 11 will throw
    }
    // This is a polyfill for custom event
    var CustomEvent = function (typeArg, eventInitDict) {
        eventInitDict = eventInitDict || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(typeArg, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
        return evt;
    };
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();
// Polyfill Element.scrollIntoViewIfNeeded
(function () {
    "use strict";
    // Polyfill adapted from https://gist.github.com/jocki84/6ffafd003387179a988e (CC-BY https://creativecommons.org/licenses/by/4.0/)
    if (!Element.prototype.scrollIntoViewIfNeeded) {
        Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded) {
            var makeRange = function (start, length) { return ({ start: start, length: length, end: start + length }); };
            var coverRange = function (inner, outer) {
                if (centerIfNeeded === false || ((outer.start < inner.end) && (inner.start < outer.end))) {
                    return Math.max((inner.end - outer.length), Math.min(outer.start, inner.start));
                }
                return (inner.start + inner.end - outer.length) / 2;
            };
            var makePoint = function (x, y) { return ({
                translate: function (dX, dY) { return makePoint(x + dX, y + dY); },
                x: x,
                y: y,
            }); };
            var absolute = function (el, pt) {
                while (el) {
                    pt = pt.translate(el.offsetLeft, el.offsetTop);
                    el = el.offsetParent;
                }
                return pt;
            };
            var target = absolute(this, makePoint(0, 0));
            var elem = this.parentNode;
            var origin;
            var extent = makePoint(this.offsetWidth, this.offsetHeight);
            while (elem instanceof HTMLElement) {
                // Apply desired scroll amount.
                origin = absolute(elem, makePoint(elem.clientLeft, elem.clientTop));
                elem.scrollLeft = coverRange(makeRange(target.x - origin.x, extent.x), makeRange(elem.scrollLeft, elem.clientWidth));
                elem.scrollTop = coverRange(makeRange(target.y - origin.y, extent.y), makeRange(elem.scrollTop, elem.clientHeight));
                // Determine actual scroll amount by reading back scroll properties.
                target = target.translate(-elem.scrollLeft, -elem.scrollTop);
                elem = elem.parentNode;
            }
        };
    }
    // Polyfill contains for SVGElement
    if (!SVGElement.prototype.contains) {
        SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
    }
})();
// Polyfill Array.from, Arrray.includes (only needed for IE)
(function () {
    // Production steps of ECMA-262, Edition 6, 22.1.2.1
    if (!Array.from) {
        Array.from = (function () {
            var toStr = Object.prototype.toString;
            var isCallable = function (fn) {
                return typeof fn === "function" || toStr.call(fn) === "[object Function]";
            };
            var toInteger = function (value) {
                var number = Number(value);
                if (isNaN(number)) {
                    return 0;
                }
                if (number === 0 || !isFinite(number)) {
                    return number;
                }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function (value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };
            // The length property of the from method is 1.
            return function from(arrayLike /*, mapFn, thisArg */) {
                // 1. Let C be the this value.
                var C = this;
                // 2. Let items be ToObject(arrayLike).
                var items = Object(arrayLike);
                // 3. ReturnIfAbrupt(items).
                if (arrayLike == null) {
                    throw new TypeError("Array.from requires an array-like object - not null or undefined");
                }
                // 4. If mapfn is undefined, then let mapping be false.
                var mapFn = arguments.length > 1 ? arguments[1] : undefined;
                var T;
                if (typeof mapFn !== "undefined") {
                    // 5. else
                    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                    if (!isCallable(mapFn)) {
                        throw new TypeError("Array.from: when provided, the second argument must be a function");
                    }
                    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }
                // 10. Let lenValue be Get(items, "length").
                // 11. Let len be ToLength(lenValue).
                var len = toLength(items.length);
                // 13. If IsConstructor(C) is true, then
                // 13. a. Let A be the result of calling the [[Construct]] internal method
                // of C with an argument list containing the single item len.
                // 14. a. Else, Let A be ArrayCreate(len).
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                // 16. Let k be 0.
                var k = 0;
                // 17. Repeat, while k < len… (also steps a - h)
                var kValue;
                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    }
                    else {
                        A[k] = kValue;
                    }
                    k += 1;
                }
                // 18. Let putStatus be Put(A, "length", len, true).
                A.length = len;
                // 20. Return A.
                return A;
            };
        })();
    }
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, "includes", {
            value: function (searchElement, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }
                var o = Object(this);
                // tslint:disable-next-line:no-bitwise
                var len = o.length >>> 0;
                if (len === 0) {
                    return false;
                }
                // tslint:disable-next-line:no-bitwise
                var n = fromIndex | 0;
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
                while (k < len) {
                    if (o[k] === searchElement) {
                        return true;
                    }
                    k++;
                }
                return false;
            }
        });
    }
})();
// Node.isConnected polyfill for IE and EdgeHTML
(function () {
    if (!("isConnected" in Node.prototype)) {
        Object.defineProperty(Node.prototype, "isConnected", {
            get: function () {
                return (!this.ownerDocument ||
                    !(
                    // tslint:disable-next-line:no-bitwise
                    this.ownerDocument.compareDocumentPosition(this) &
                        this.DOCUMENT_POSITION_DISCONNECTED));
            },
        });
    }
})();

//# sourceMappingURL=Polyfills.js.map
